module.exports = __webpack_public_path__ + "img/Group4_26.f7beba6a.jpg";